import React from "react";
import { TableHeader } from "../../commons";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import CheckInScheduleTableData from "./CheckInScheduleTableData";
import { GetCheckInDetailDataType } from "../../../redux/mySpace/mySpaceTypes";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../commons/ScrollToTop";

type AppProps = {
  tableHeader: TableHeadersType[];
  data: [] | GetCheckInDetailDataType[];
  handleEditCheckInSchedule?: (data: string) => void;
  type?: string;
  handleCheckInFeedBackModal?: (id: string) => void;
  handleViewUsersDetails?: (id: string) => void;
  isMyCheckInsEditPresent?: boolean;
  fetching: boolean;
};

const CheckInScheduleTable = ({
  tableHeader,
  data,
  handleEditCheckInSchedule,
  type,
  handleCheckInFeedBackModal,
  isMyCheckInsEditPresent,
  handleViewUsersDetails,
  fetching,
}: AppProps) => {
  return (
    <div className="jobsType" style={{ overflow: "auto" }}>
      <table className="table thead-light table-bordered">
        <thead className="text-start sticky-table-header-without-zindex">
          <TableHeader tableHeader={tableHeader} />
        </thead>
        <tbody>
          <CheckInScheduleTableData
            tableHeader={tableHeader}
            data={data}
            type={type}
            handleCheckInFeedBackModal={handleCheckInFeedBackModal}
            handleEditCheckInSchedule={handleEditCheckInSchedule}
            isMyCheckInsEditPresent={isMyCheckInsEditPresent}
            handleViewUsersDetails={handleViewUsersDetails}
          />
          <div style={{ display: fetching ? "none" : "inline" }}>
            <ScrollToTop />
          </div>
        </tbody>
      </table>
    </div>
  );
};

export default CheckInScheduleTable;
